export default "__VITE_ASSET__D8om1WVn__"